//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useCallback, useContext, useMemo, useRef } from "react"

//#endregion

const ContextDrop = createContext();

//-----------------------------------------------------------------
export function DropProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref_drag = useRef();

  const getDrag = useCallback( _getDrag , [] );
  const setDrag = useCallback( _setDrag , [] );

  const values = useMemo( createValues, [getDrag, setDrag] );

  //#endregion

  function createValues() {
    return {
      getDrag,
      setDrag,
    }
  }

  function _getDrag() {
    return ref_drag.current || {};
  }

  function _setDrag( type, value ) {
    ref_drag.current = { type, value }
  }

  return (
    <ContextDrop.Provider value={ values }>
      {children}
    </ContextDrop.Provider>
  );
};

//-----------------------------------------------------------------
export function useDrop() {
  //-----------------------------------------------------------------
  return useContext( ContextDrop );
}